export default "__VITE_ASSET__ec33acc4__"